import React, { useState } from "react";
import { Button } from "@heroui/react";
import FinalReviewStep from "../../pages/deals/createDeal/finalReviewStep";

interface AgreementSignPanelProps {
  pdfUrl?: string | null;
  isSubmitting: boolean;
  submitLabel: string;
  onSign: (signatureDataUrl: string) => void;
}

const AgreementSignPanel: React.FC<AgreementSignPanelProps> = ({
  pdfUrl,
  isSubmitting,
  submitLabel,
  onSign,
}) => {
  const [signature, setSignature] = useState<string | null>(null);

  const handleSign = () => {
    if (!signature) return;
    onSign(signature);
  };

  return (
    <div className="flex flex-col gap-4">
      <FinalReviewStep
        pdfUrl={pdfUrl}
        signature={signature}
        onSignatureChange={setSignature}
      />
      <Button
        radius="full"
        color="primary"
        isDisabled={!signature || isSubmitting}
        isLoading={isSubmitting}
        onPress={handleSign}
      >
        {submitLabel}
      </Button>
    </div>
  );
};

export default AgreementSignPanel;
